// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PrimeNgModule } from "@primeng";

import { GridModule } from "@features/grid";
import { BbCardModule } from "@features/bb-card";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { FilterModule } from "@features/filter";
import { CreatePlayerDialogComponent } from "./create-player-dialog.component";
import { DuplicatePatientsDialogComponent } from "./duplicate-patients-dialog.component";
import { CreatePlayerFormComponent } from "./create-player-form.component";
import { CreatePlayerRoutingComponent } from "./create-player-routing.component";
import { PlayerNHSFullRequestComponent } from "./player-nhs-full-request.component";
import { MergePatientDialogComponent } from "@project/merge-patient/merge-patient.dialog.component";
import { AvatarModule } from "primeng/avatar";
import { TooltipModule } from "primeng/tooltip";

@NgModule({
    declarations: [
        CreatePlayerDialogComponent,
        DuplicatePatientsDialogComponent,
        CreatePlayerFormComponent,
        CreatePlayerRoutingComponent,
        PlayerNHSFullRequestComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        BbCardModule,
        FilterModule,
        PrimeNgModule,
        MiproSharedModule,
        MergePatientDialogComponent,
        AvatarModule,
        TooltipModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [CreatePlayerDialogComponent, DuplicatePatientsDialogComponent, CreatePlayerFormComponent, PlayerNHSFullRequestComponent]
})
export class PlayerSharedModule {}
